import { Badge } from "react-bootstrap";
import { IfrValidation, isIfrValidationCurrentAndOk } from "../models/flight";

// File-status badge for a non-VFR plan BEFORE it is filed: it reflects the stored IFPUV pre-validation of
// the current FPL. A non-VFR plan is only genuinely "Ready to File" once IFPS validation passes (filing is
// blocked until then), so "Ready to File" comes AFTER the check. Colours match what users already know —
// yellow "Ready to File" (same as a VFR plan), green stays reserved for a filed FPL — so the pre-validation
// step gets its own distinct colour.
//   purple "Ready to validate" — not validated yet, or stale (the FPL changed, e.g. a date/time edit); the
//                                FPL page re-validates on open. Not fileable yet.
//   yellow "Ready to File" — IFPS-validated clean for the current FPL — now genuinely ready to file.
//   red    "IFPS errors"   — IFPS rejected the current route (must fix it before filing).
// After filing, the live IFPS state is shown by IfpsStateBadge instead.
export default function IfrFileStatusBadge({ ifrValidation, fplCode }: { ifrValidation?: IfrValidation; fplCode?: string }) {
  if (isIfrValidationCurrentAndOk(ifrValidation, fplCode)) {
    return (
      <Badge bg="warning" text="dark">Ready to File</Badge>
    );
  }
  const isCurrent = !!ifrValidation && !!fplCode && ifrValidation.fplCode === fplCode;
  if (isCurrent && ifrValidation!.result === "errors") {
    return (
      <Badge bg="danger">IFPS errors</Badge>
    );
  }
  return (
    // bg="none" avoids the bootstrap .bg-* utility (whose !important would beat the inline colour), so the
    // custom purple actually renders. Colour + white text set inline.
    <Badge bg="none" style={{ backgroundColor: "#6f42c1", color: "#fff" }}>Ready to validate</Badge>
  );
}
